<script setup>
import {defineEmits, defineModel, defineProps} from 'vue'

const modelValue = defineModel({required: true})
const emit = defineEmits(['change'])

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  value: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  name: {
    type: String,
    required: true,
  },
})
const onChange = value => {
  emit('change', value)
}
</script>

<template>
  <input
    v-model="modelValue"
    :disabled="props.disabled"
    class="form-check-input"
    type="radio"
    :name="props.name"
    :id="props.id"
    :value="props.value"
    @change="onChange"
  />
</template>

<style lang="scss" scoped>
.form-check-input[type='radio'] {
  appearance: none;
  -webkit-appearance: none;
  background-color: transparent;
  border: 1px solid #d1d5db;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  position: relative;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  margin-right: 8px;
  margin-top: 0;

  &:checked {
    border: 2px solid $primary;
  }
}

.form-check-input[type='radio']::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 9px;
  height: 9px;
  background-color: $primary;
  border-radius: 50%;
  transform: translate(-50%, -50%) scale(0);
  transition: transform 0.2s ease-in-out;
}

.form-check-input[type='radio']:checked::before {
  transform: translate(-50%, -50%) scale(1);
}

.form-check-input[type='radio']:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.was-validated .form-check-input:valid:checked,
.form-check-input.is-valid:checked {
  background-color: transparent;
}
</style>
